import React from 'react';
import {
  FDBox,
  FDContentContainer, FDStack,
} from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

export const ContentWrapper = ({ children }) => {
  const isMobile = useMobileLayout();

  return (
    <>
      <FDBox>
        <FDContentContainer maxWidth={'xl'}>
          <FDStack direction={'column'} alignItems={'center'} spacing={4} paddingX={isMobile ? 1 : 4}>
            {children}
          </FDStack>
        </FDContentContainer>
      </FDBox>
    </>
  );
};
